module.exports = "/src/views/player/oressale/assets/images/wood_oak.png";